import React, { useRef, useState } from 'react'

import { LeftArrowThinIcon, RightArrowThinIcon } from 'images'
import FacebookLinkComponent from './FacebookLinkComponent'
import InstagramLinkComponent from './InstagramLinkComponent'

const CarouselPreview = (props) => {
  const {cards, mobileView = false, onLoaded, type = 'facebook', callToAction} = props
  const carouselRef = useRef(null)

  const [selectedInstagramCard, setSelectedInstagramCard] = useState(0)

  if (!Array.isArray(cards) || !cards.length) return null

  const handleScroll = (direction) => {
    if (!carouselRef.current) return
    const scrollOffset = mobileView ? 280 : 480
    carouselRef.current.scrollBy({
      left: direction === 'left' ? -scrollOffset : scrollOffset,
      behavior: 'smooth',
    })
  }

  switch (type) {
    case 'facebook':
      return (
        <div className="carousel-preview-wrapper">
          <button type="button" className="button-scroll button-scroll-left" onClick={() => handleScroll('left')}>
            <LeftArrowThinIcon width={8} />
          </button>
          <div className="carousel-preview" ref={carouselRef}>
            {cards.map((card, index) => (
              <FacebookLinkComponent
                key={card?.id || `${index}-${card?.url || card?.media?.url || 'facebook-card'}`}
                card={card}
                mobileView={mobileView}
                onLoaded={onLoaded}
                callToAction={callToAction}
              />
            ))}
          </div>
          <button type="button" className="button-scroll button-scroll-right" onClick={() => handleScroll('right')}>
            <RightArrowThinIcon width={8} height={8}/>
          </button>
        </div>
      )
    case 'instagram':
    case 'reels':
      return (
        <div className="carousel-preview-wrapper">
          {selectedInstagramCard > 0 && <button type="button" className="button-scroll button-scroll-left" onClick={() => setSelectedInstagramCard(prev => prev - 1)}>
            <LeftArrowThinIcon width={8} />
          </button>}
          <div className="instagram-carousel-preview" ref={carouselRef}>
            <InstagramLinkComponent
              card={cards[selectedInstagramCard]}
              onLoaded={onLoaded}
              callToAction={callToAction}
              type={type}
            />
          </div>
          {cards.length > 1 && selectedInstagramCard < cards.length - 1 && <button type="button" className="button-scroll button-scroll-right" onClick={() => setSelectedInstagramCard(prev => prev + 1)}>
            <RightArrowThinIcon width={8} height={8}/>
          </button>}
          
          <div className="instagram-carousel-dots">
            {cards.map((_, index) => {
              return (
                <div key={index} className={`instagram-carousel-dot ${selectedInstagramCard === index ? 'active' : ''}`} />
              )
            })}
          </div>
        </div>
      )
    default:
      return null
  }
}

export default CarouselPreview